import { render, staticRenderFns } from "./cow-basic-info.vue?vue&type=template&id=3e428b64&scoped=true&"
import script from "./cow-basic-info.vue?vue&type=script&lang=js&"
export * from "./cow-basic-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e428b64",
  null
  
)

export default component.exports